import { Box } from '@mui/material'
import { useAuthStore } from 'context/AuthStore'
import { HEAD_UNDERWRITER, SUPER_UNDERWRITER } from 'lib/constants/roles'
import { dateDiff } from 'lib/utils'
import { useEffect, useState, useMemo } from 'react'
import { useHomeStore } from 'context/HomeStore'

export const TimerUnderwriterStatus = ({ data = {} }) => {
  const { authStore } = useAuthStore()
  const {
    homeStore: { activeApplication }
  } = useHomeStore()
  const [timeElapsed, setTimeElapsed] = useState('00:00')

  const dateField = useMemo(() => {
    if (authStore.isUserRole === SUPER_UNDERWRITER) return 'assignToSuperUnderwriterDate'
    if (authStore.isUserRole === HEAD_UNDERWRITER) return 'assignToHeadUnderwriterDate'
    if (activeApplication.status.code === 'userCheckCollateral') return 'assignToUnderCheckCollateralDate'
    if (activeApplication.status.code === 'userCheckBankDocs') return 'assignToUnderCheckBankDocsDate'
    if (activeApplication.status.code === 'userUnderwriterDecision') return 'assignToUnderInitCheckDate'
    
    return 'assignToUnderwriterDate'
  }, [authStore])

  useEffect(() => {
    const assignedDate = data?.activity?.[dateField]
    if (!assignedDate) return

    const startTime = new Date(assignedDate).getTime()
    const updateTime = () => {
      const now = new Date().getTime()
      const diff = now - startTime
      setTimeElapsed(dateDiff(diff))
    }

    const intervalId = setInterval(updateTime, 1000)
    return () => clearInterval(intervalId)
  }, [data?.activity, dateField])

  return <Box>В работе — {timeElapsed}</Box>
}
